export type NotificationType = "success" | "info" | "warning" | "error";